import type { ComponentProps } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type ToolbarButtonProps = Omit<ComponentProps<typeof Button>, "type" | "size" | "variant"> & {
  // Hem title (ipucu) hem aria-label olarak kullanılır.
  label: string;
  // Verilirse aria-pressed ile aç/kapa durumunu bildirir.
  active?: boolean;
};

// Araç çubuğundaki ikon düğmesi. ref de props üzerinden geçer (React 19), böylece
// Radix Trigger asChild ile sarılabilir.
export function ToolbarButton({ label, active, className, children, ...props }: ToolbarButtonProps) {
  return (
    <Button
      type="button"
      size="sm"
      variant={active ? "secondary" : "ghost"}
      className={cn("h-7 min-w-7 px-1.5 [&_svg]:size-3.5", className)}
      title={label}
      aria-label={label}
      aria-pressed={active === undefined ? undefined : active}
      {...props}
    >
      {children}
    </Button>
  );
}

export function ToolbarSeparator() {
  return <div role="separator" aria-orientation="vertical" className="mx-0.5 h-5 w-px bg-border" />;
}
